import { css } from 'styled-components';
import {
  getTypography, TypographyName, ThemedFunctor, BreakpointQueryName,
  getSpacing,
  SpacingName,
} from '@doveit/lego';

const pictureSize = '13.2rem';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)}
  border: 1px solid ${theme.palettes.neutrals.light};
  display: flex;
  flex-direction: column;
  gap: ${theme.spaceUnits.mobile.MEDIUM};

  ${onClick && `
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    }
  `}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    gap: ${theme.spaceUnits.desktop.MEDIUM};
    align-items: center;
    flex-direction: row;
  }
`;

export const primary: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${theme.spaceUnits.mobile.MEDIUM};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    gap: ${theme.spaceUnits.desktop.MEDIUM};
    align-items: center;
    flex-direction: row;
  }
`;

export const info: ThemedFunctor = () => css`
  flex-grow: 1;
`;

export const picture: ThemedFunctor = ({
  theme,
  $pictureURL,
}) => css`
  color: ${theme.palettes.neutrals.light};
  background-color: ${theme.palettes.neutrals.lighter};
  flex-shrink: 0;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 25rem;
  height: ${pictureSize};

  ${$pictureURL && `
    background: ${theme.palettes.neutrals.lighter} url('${$pictureURL}');
    background-size: cover;
    background-position: center center;
  `}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: ${pictureSize};
    max-width: ${pictureSize};
  }
`;

export const name: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.brand.primary};

  a {
    text-decoration: none;
  }
`;

export const detail: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  color: ${theme.palettes.neutrals.dark};
  display: flex;
  align-items: center;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    gap: ${theme.spaceUnits.desktop.SMALLEST};
  }
`;

export const openingHours: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: flex;
  flex-direction: column;
  gap: ${theme.spaceUnits.mobile.SMALLEST};
  color: ${theme.palettes.neutrals.dark};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    gap: ${theme.spaceUnits.desktop.SMALLEST};
  }
`;

export const badge: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
`;

export const agents: ThemedFunctor = ({ theme }) => css`
  padding-top: ${theme.spaceUnits.mobile.MEDIUM};
  border-top: 1px solid ${theme.palettes.neutrals.light};
  gap: ${theme.spaceUnits.mobile.SMALLER};
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    border-top: 0;
    flex-shrink: 0;
    border-left: 1px solid ${theme.palettes.neutrals.light};
    gap: ${theme.spaceUnits.desktop.SMALLER};
    padding: 0 0 0 ${theme.spaceUnits.desktop.MEDIUM};
    height: ${pictureSize};
    width: 21rem;
  }
`;
